import { FC } from 'react';

import { SectionSubtitleProps } from './SectionSubtitle.types';
import CampaignTitleCard from '../CampaignTitleCard/CampaignTitleCard';
import { StyledSectionSubtitle } from './SectionSubtitle.styles';

const SectionSubtitle: FC<SectionSubtitleProps> = ({
  isLoading = false,
  labelLeftTop,
  labelLeftBottom,
  labelRightTop,
  labelRightBottom,
  parenthesisSubtitle,
  numberLeft,
  numberRight,
}) => {
  return (
    <>
      {!isLoading && (
        <StyledSectionSubtitle>
          <CampaignTitleCard
            title={labelLeftTop}
            subtitle={labelLeftBottom}
            value={numberLeft}
            parenthesisSubtitle={parenthesisSubtitle}
          />
          <CampaignTitleCard
            title={labelRightTop}
            subtitle={labelRightBottom}
            value={numberRight + '%'}
            parenthesisSubtitle={parenthesisSubtitle}
          />
        </StyledSectionSubtitle>
      )}
    </>
  );
};

export default SectionSubtitle;
